import {Component} from '@angular/core';
import {JwtService} from './shared/services/jwt.service';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  // eslint-disable-next-line
  selector: 'body',
  template: '<router-outlet></router-outlet>'
})
export class AppComponent {
  constructor(private jwt: JwtService, private router: Router) {
    if (this.jwt.isTokenExpired()) {
      this.router.navigate(['/auth/login']);
      return;
    }

    if (this.router.url === '') {
      this.router.navigate(['/bids/customer']);
    }
    return;
  }
}



// WEBPACK FOOTER //
// D:/Projects/bid/frontend/src/app/app.component.ts